import BaseComponent from "../../../baseComponent.js";
import ValueTypes from "../../../../core/constants/valueTypes.js";

export default class DataProfileDetail extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let fields = [];
    let profileName = "";
    if (this.props.dataProfile) {
      profileName = this.props.dataProfile.name;
      for (let i = 0; i < this.props.dataProfile.fields.length; i++) {
        let field = this.props.dataProfile.fields[i];
        if (field.fieldId != null) {
          fields.push(<tr key={i}>
            <td>{field.name}</td>
            <td>{field.fieldId}</td>
            <td>{ValueTypes[field.valueType]}</td>
          </tr>);
        }
      }
    }

    return (
      <div style={{display: "flex", flexDirection: "column"}}>
        <div className="title">{profileName}</div>
        <table>
          <thead>
          <tr>
            <th>Field Name</th>
            <th>Field Id</th>
            <th style={{width: "70px"}}>Field Type</th>
          </tr>
          </thead>
          <tbody>
          {fields}
          </tbody>
        </table>
      </div>
    )
  }
}














// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataset/dataProfileDetail.jsx